import React from "react";
import './Main.scss';
import Currency from "../components/Currency";
import CurrencyPrivat from "../components/CurrencyPrivat";

function Main() {
    return (
        <div className="main">
            <div className="main-wrapper">
                <div className="main-container">
                    <Currency/>
                </div>
                <div className="main-container">
                    <CurrencyPrivat/>
                </div>
            </div>
        </div>
    );
}

export default Main;
